import { Type } from 'class-transformer';

export class OAuthInitRes {
    authorizationUrl = '';
    state = '';
}

export class CompleteMicrosoftCalendarIntegrationReq {
    authorizationCode = '';
    state = '';
}

export class CompleteGoogleCalendarIntegrationReq {
    authorizationCode = '';
    state = '';
}

export class CreateIcsCalendarIntegrationReq {
    displayName = '';
    url = '';
    username?: string;
    password?: string;
    syncMode = 0;
    importAppointments = true;
    importAbsences = true;
}

export class InitMicrosoftCalendarIntegrationReq {
    displayName = '';
    tenantHint?: string;
    oAuthClientId?: string;
    oAuthClientSecret?: string;
    syncMode = 0;
    importAppointments = true;
    importAbsences = true;
    exportAbsences = false;
}

export class InitGoogleCalendarIntegrationReq {
    displayName = '';
    syncMode = 0;
    importAppointments = true;
    importAbsences = true;
    exportAbsences = false;
    oAuthClientId: string = '';
    oAuthClientSecret: string = '';
}

export class UpdateCalendarSourceSelectionReq {
    selectedSourceIds: string[] = [];
}

export class VUserIntegrationRes {
    guid = '';
    userId = 0;
    type = 0;
    provider = 0;
    displayName = '';
    status = 0;
    isEnabled = false;
    isActive = false;
    lastSyncStartedAtUtc?: string;
    lastSyncSucceededAtUtc?: string;
    lastSyncError?: string;
}

export class VUserCalendarSourceRes {
    guid = '';
    externalCalendarId = '';
    name = '';
    isPrimary = false;
    isSelected = false;
    isReadOnly = false;
    lastSyncedAtUtc?: string;
}

export class VUserCalendarIntegrationRes extends VUserIntegrationRes {
    syncMode = 0;
    importAppointments = false;
    importAbsences = false;
    exportAbsences = false;
    baseUrl?: string;
    tenantId?: string;

    @Type(() => VUserCalendarSourceRes)
    sources: VUserCalendarSourceRes[] = [];
}

export class VUserCalendarIntegrationUReq {
    displayName = '';
    isEnabled = false;
    syncMode = 0;
    importAppointments = true;
    importAbsences = true;
    exportAbsences = false;
}

export interface CalendarSourceActionReq {
    sourceId: string;
}

export interface DisconnectCalendarIntegrationReq {
    clearTokens: boolean;
}

export class CalendarImportPreviewEventRes {
    startUtc?: string | null = null;
    endUtc?: string | null = null;
    isAllDay = false;
    title?: string | null = null;
    description?: string | null = null;
    rawText?: string | null = null;
    color?: string | null = null;
    rRule?: string | null = null;
    recurrenceTimeZoneId?: string | null = null;
    isRecurring = false;
    isAbsenceLike = false;

    constructor(init?: Partial<CalendarImportPreviewEventRes>) {
        Object.assign(this, init);
    }
}

export class CalendarImportPreviewRes {
    displayName?: string | null = null;
    eventCount = 0;
    minStartUtc?: string | null = null;
    maxEndUtc?: string | null = null;
    warnings: string[] = [];
    events: CalendarImportPreviewEventRes[] = [];

    constructor(init?: Partial<CalendarImportPreviewRes>) {
        Object.assign(this, init);
        this.warnings = init?.warnings ?? [];
        this.events = (init?.events ?? []).map(x => new CalendarImportPreviewEventRes(x));
    }
}

export class CalendarImportCommitRes {
    createdEntries = 0;
    updatedEntries = 0;
    skippedEntries = 0;
    conflictCount = 0;
    messages: string[] = [];
    preview?: CalendarImportPreviewRes | null = null;

    constructor(init?: Partial<CalendarImportCommitRes>) {
        Object.assign(this, init);
        this.messages = init?.messages ?? [];
        this.preview = init?.preview ? new CalendarImportPreviewRes(init.preview) : null;
    }
}